import React from "react";
import {observer} from "mobx-react-lite";
import {PlatformBasedComponent} from "../../basic-components/layout/platform-based.component";
import {HomeWebappPage} from "./web/home.webapp.page";
import {HybridHomePage} from "./hybrid/hybrid-home.page";
import {PortalTypeBasedComponent} from "../../basic-components/layout/portal-type-based.component";
import {AgencyHomeWebappPage} from "../agency/home/agency-home-webapp.page";

export const HomePage: React.FC = observer(() => {
    const renderForB2C = () => {
        return (
            <PlatformBasedComponent renderForWebApp={() => (<HomeWebappPage/>)}
                                    renderForHybrid={() => (<HybridHomePage/>)}/>
        );
    }
    const renderForAgency = () => {
        return (
            <AgencyHomeWebappPage />
        );
    }
    return (
        <PortalTypeBasedComponent renderForB2C={renderForB2C}
                                  renderForAgency={renderForAgency}/>
    );
});
